import moment, { Moment } from 'moment';

export const formatBr = 'DD/MM/YYYY  hh:mm';

export const currentDate = moment(new Date());

export const commercialCurrentDate: Moment = (() => {
  const dayOfWeek = currentDate.day();

  if (dayOfWeek === 3 || dayOfWeek === 6) {
    return currentDate.clone().add(2, 'days');
  }

  if (dayOfWeek === 5) {
    return currentDate.clone().add(3, 'days');
  }
  return currentDate.clone().add(1, 'day');
})();

const KLOK_UNAVAILABLE_COMMERCIAL_WEEKDAYS = [0, 4];

const KLOK_COMMERCIAL_WINDOW_DAYS: Record<number, number> = {
  0: 8,
  1: 4,
  2: 4,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
};

export const isKlokCommercialDateDisabled = (
  value: Moment | null,
  outDate?: Moment | string | null,
): boolean => {
  if (!value || !outDate) return true;
  if (KLOK_UNAVAILABLE_COMMERCIAL_WEEKDAYS.includes(value.day())) return true;

  const windowStart = moment(outDate).startOf('day');
  const windowEnd = windowStart.clone().add(KLOK_COMMERCIAL_WINDOW_DAYS[windowStart.day()], 'days');

  return !value.isBetween(windowStart, windowEnd, 'day', '[]');
};
